import { Dispatch, SetStateAction } from 'react';
import { createContext } from 'use-context-selector';

export const settingsPanelsNames = [
  'Title',
  'Answers',
  'General',
  'Layout',
  'Validation',
  'Logic',
  'Other',
  'Styles',
  'Tags',
  'AdditionalScreens',
  'Scores',
  'Language',
  'SurveyView',
  'Controls',
  'Layers',
  'Buffer',
  'FormsConfig',
] as const;

export type SettingsPanelsNames = (typeof settingsPanelsNames)[number];

export type PanelsExpansionState = Record<SettingsPanelsNames, boolean>;

export const panelsExpansionInitialState: Record<SettingsPanelsNames, boolean> = Object.fromEntries(
  settingsPanelsNames.map((key) => [key, false]),
) as Record<SettingsPanelsNames, boolean>;

const defaultValues: PanelsExpansionContextValues = {
  panelsExpansionState: panelsExpansionInitialState,
};

type PanelsExpansionContextValues = {
  panelsExpansionState: PanelsExpansionState;
  setPanelsExpansionState?: Dispatch<SetStateAction<PanelsExpansionState>>;
};

export const PanelsExpansionContext = createContext<PanelsExpansionContextValues>(defaultValues);
